import { render, staticRenderFns } from "./ImportKPAModal.vue?vue&type=template&id=b71843fe&scoped=true"
import script from "./ImportKPAModal.vue?vue&type=script&lang=js"
export * from "./ImportKPAModal.vue?vue&type=script&lang=js"
import style0 from "./ImportKPAModal.vue?vue&type=style&index=0&id=b71843fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b71843fe",
  null
  
)

export default component.exports